export class TenantInfo {
    tenantId: string;
    region: string;
    identityPoolId: string;
    userPoolId: string;
    cognitoDomainPrefix: string;
    clientId: string;
    apiUrl: string;
    api2Url: string;
    bucket: string;
    utcOffset: string;
    utcEndOfDayHour: number;
    postEndOfDayHours: number;
    adminApplicationUrl: string;
    loginStrategy: 'COGNITO' | 'LDAP';
}
